import { Link } from "react-router-dom";

const quickCategories = [
  { name: "剧情", icon: "ri-book-open-line", desc: "人间百态" },
  { name: "动作", icon: "ri-run-line", desc: "枪火追车" },
  { name: "科幻", icon: "ri-planet-line", desc: "未来想象" },
  { name: "喜剧", icon: "ri-emotion-happy-line", desc: "会心一笑" },
  { name: "爱情", icon: "ri-heart-3-line", desc: "怦然心动" },
  { name: "恐怖", icon: "ri-ghost-line", desc: "暗夜惊魂" },
  { name: "犯罪", icon: "ri-police-car-line", desc: "灰色地带" },
  { name: "冒险", icon: "ri-compass-3-line", desc: "远方寻宝" },
];

export default function CategoryQuickLinks() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 py-10 md:px-6">
      <div className="mb-6 flex items-center gap-3">
        <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className="ri-apps-2-line text-xl"></i>
        </span>
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
            按类型快速浏览
          </h2>
          <p className="mt-0.5 font-label text-sm text-foreground-600">
            从类型出发，找到你钟爱的那一部
          </p>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
        {quickCategories.map((cat) => (
          <Link
            key={cat.name}
            to={`/category?genre=${encodeURIComponent(cat.name)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-accent-300 hover:bg-accent-50"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-accent-100 group-hover:text-accent-600">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <div>
              <p className="font-heading text-base font-semibold text-foreground-950">
                {cat.name}片
              </p>
              <p className="font-label text-xs text-foreground-500">
                {cat.desc}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}